import React from 'react'
import { FormikStepProps } from '../../../../components/form/wizzard/FormikStepper'
import { Grid } from '@mui/material'
import InputField from '../../../../components/form/InputField'
import UrlRedirectCheck from '../../../../components/form/UrlRedirectCheck'
import { useAppTranslations } from '../../../../utils/hooks/useAppTranslations'
import MarketSelectField from '../../../../components/form/MarketSelectField'
import IabAutoCompleteField from '../../../../components/form/IABAutoCompleteField'
import { CampaignCreateAdgroupsSection } from './CampaignCreateAdgroupsSection'
import CampaignCopperOpportunityFields from './CampaignCopperOpportunityFields'
import { CampaignCreateCopperProvider } from './CampaignCreateCopperContext'

const CampaignDetailStep: React.FC<FormikStepProps> = () => {
  const t = useAppTranslations()

  return (
    <Grid
      container
      direction="row"
      spacing={3}
      sx={{
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
      }}
    >
      <Grid container direction="column" size={6}>
        <Grid>
          <InputField name={'name'} label={'commons.name'} type={'text'} fullWidth required variant="outlined" />
        </Grid>
        <Grid>
          <InputField
            name={'advertiserDomainName'}
            label={'campaign.details.advertiserDomainName'}
            type={'text'}
            fullWidth
            required
            variant="outlined"
          />
          <UrlRedirectCheck name="advertiserDomainName" />
        </Grid>
      </Grid>
      <Grid container direction="column" size={6}>
        <Grid>
          <IabAutoCompleteField name={'iabCategory'} label={t('commons.iabCategory')} />
        </Grid>
        <Grid>
          <MarketSelectField name={'marketId'} label={t('commons.market')} required variant="outlined" />
        </Grid>
      </Grid>
      <Grid size={12}>
        <CampaignCreateCopperProvider>
          <CampaignCopperOpportunityFields />
          <CampaignCreateAdgroupsSection />
        </CampaignCreateCopperProvider>
      </Grid>
    </Grid>
  )
}

export default CampaignDetailStep
